"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("antd/dist/antd.css");
var _antd2 = require("antd");
require("./Switch.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomSwitch = _ref => {
  let {
    onChange,
    disabled,
    defaultChecked,
    checked,
    checkedChildren,
    unCheckedChildren,
    testId
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_antd2.Switch, {
    "data-testid": testId || "",
    checkedChildren: checkedChildren,
    unCheckedChildren: unCheckedChildren,
    defaultChecked: defaultChecked,
    checked: checked,
    disabled: disabled,
    onChange: onChange
  });
};
var _default = exports.default = CustomSwitch;